import { useQuery, useSubscription } from "@apollo/react-hooks";
import {
  MY_HR_GET_PAYCARD_IN_HTML,
  MY_HR_PAYCARDS_SUBSCRIPTION,
} from "my-hr/graphql";
import { useOcPolling } from "oc/hooks";

interface UseMyHrPaycardParams {
  contract: string;
  year: string;
  month: string;
}

export const useMyHrPaycard = ({
  contract,
  year,
  month,
}: UseMyHrPaycardParams) => {
  const { data, loading, error, refetch } = useQuery(
    MY_HR_GET_PAYCARD_IN_HTML,
    {
      skip: !contract || !year || !month,
      fetchPolicy: "cache-and-network",
      pollInterval: useOcPolling(1000 * 60),
      variables: { contractCode: contract, year, month },
    },
  );

  const { error: subscriptionError } = useSubscription(
    MY_HR_PAYCARDS_SUBSCRIPTION,
    {
      onData: () => {
        refetch();
      },
    },
  );

  if (subscriptionError) {
    console.log({
      component: "usePaycard",
      errorDescription:
        "Error occured when fetch data with MY_HR_PAYCARDS_SUBSCRIPTION query",
      error: error,
    });
  }

  return {
    data: data?.getPaycardInHTML,
    loading,
    error,
  };
};

export default useMyHrPaycard;
